import {Controller} from "@hotwired/stimulus";
import intlTelInput from 'intl-tel-input/intlTelInputWithUtils';
import 'intl-tel-input/build/css/intlTelInput.css';
import './../css/intl-tel-input-custom.css';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = [
        "input",
        "country",
        "e164",
    ];

    static values = {
        options: Object,
    };

    connect() {
        this.iti = intlTelInput(this.inputTarget, this.optionsValue);

        this.inputTarget.addEventListener('input', this.dispatchChangeEvents.bind(this));
        this.inputTarget.addEventListener('countrychange', this.dispatchChangeEvents.bind(this));
        this.inputTarget.addEventListener('change', this.onChangeInput.bind(this));
        this.inputTarget.addEventListener('blur', this.syncHiddenFields.bind(this));

        // Google Autofill fills the visible input without firing `input`, so the
        // debounced sync never runs and the hidden e164 field stays empty. Recompute
        // it from the visible value right before POST (capture = run before submit).
        this.form = this.element.closest('form');
        this.form?.addEventListener('submit', this.syncHiddenFields.bind(this), true);

        this.observeForInvalidInput();
    }

    disconnect() {
        this.inputTarget.removeEventListener('input', this.dispatchChangeEvents.bind(this));
        this.inputTarget.removeEventListener('countrychange', this.dispatchChangeEvents.bind(this));
        this.inputTarget.removeEventListener('change', this.onChangeInput.bind(this));

        this.iti.destroy();
        this.observer.disconnect();
    }

    dispatchChangeEvents(event) {
        if (this.updateHiddenFieldsTimeout) {
            clearTimeout(this.updateHiddenFieldsTimeout);
        }

        this.updateHiddenFieldsTimeout = setTimeout(() => this.syncHiddenFields(), 500);
    }

    syncHiddenFields() {
        this.countryTarget.value = this.iti.getSelectedCountryData().iso2;
        this.countryTarget.dispatchEvent(new CustomEvent('change', {bubbles: true}));
        this.e164Target.value = this.iti.getNumber();
        this.e164Target.dispatchEvent(new CustomEvent('change', {bubbles: true}));
        this.inputTarget.dispatchEvent(new CustomEvent('change', {
            bubbles: true,
            detail: {doNotStopPropagation: true},
        }));
    }

    observeForInvalidInput() {
        this.observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'childList' || mutation.type === 'attributes') {
                    this.checkAndAddInvalidClass();
                }
            });
        });

        this.observer.observe(this.element, {
            childList: true,
            subtree: true,
            attributes: true
        });

        this.checkAndAddInvalidClass();
    }

    checkAndAddInvalidClass() {
        const invalidFeedback = this.element.querySelector('.invalid-feedback');

        if (invalidFeedback) {
            if (!this.inputTarget.classList.contains('is-invalid')) {
                this.inputTarget.classList.add('is-invalid');
            }
        } else {
            if (this.inputTarget.classList.contains('is-invalid')) {
                this.inputTarget.classList.remove('is-invalid');
            }
        }
    }

    onChangeInput(event) {
        if (event?.detail?.doNotStopPropagation) {
            return;
        }

        event.stopPropagation();
    }
}
